// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"spinner-icon_loadingSpinner__0G91L","spin":"spinner-icon_spin__igSwS"};